import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class TpinUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getTpinData(req);
    }
}
export default TpinUseCase;
